'use strict';

exports.__esModule = true;
var VERSION = '1.5.2';

exports.default = VERSION;


//////////////////
// WEBPACK FOOTER
// ./~/kindergarten/lib/VERSION.js
// module id = 7SbS
// module chunks = 0